import styled from 'styled-components';
import { SelectHTMLAttributes } from 'react';

import { IoChevronDown } from 'react-icons/io5';
import { forwardRef } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement>{
  error?: boolean;
  fullWidth?: boolean;
  width?: string;
  children: React.ReactNode;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SelectWrapper = styled.div<SelectProps>`
  position: relative;
  display: inline-block;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  opacity: ${props => props.disabled ? 0.5 : 1};
`;

const StyledSelect = styled.select<SelectProps>`
    padding: 10px 17px;
    padding-right: 36px;
    font-size: 14px;
    font-weight: 700;
    border: 1px solid ${props => props.error ? '#dc3545' : '#ddd'};
    border-radius: 4px;
    transition: all 0.2s ease;
    width: ${props => props.width || '100%'};
    background: white;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    appearance: none;
    color: #333;

    &:focus {
        outline: none;
        border-color: ${props => props.error ? '#dc3545' : 'rgb(77, 105, 156)'};
        box-shadow: 0 0 0 2px ${props => props.error ? 'rgba(220, 53, 69, 0.25)' : 'rgba(77, 105, 156, 0.25)'};
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }

   
`;

export const Option = styled.option`
  padding: 8px; // Это свойство может работать в некоторых браузерах
  color: #333;
  background-color: white;

  &:checked {
    background-color: rgb(77, 105, 156);
    color: white;
  }
`;

const IconWrapper = styled.div`  position: absolute;
  right: 12px;
  top: 60%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
`;

export const Select = forwardRef(({ children, ...props }: SelectProps, ref) => (
  <SelectWrapper fullWidth={props.fullWidth}>
    <StyledSelect {...props} ref={ref as React.RefObject<HTMLSelectElement>} onChange={props.onChange}>
      {children}
    </StyledSelect>
    <IconWrapper>
      <IoChevronDown size={16} />
    </IconWrapper>
  </SelectWrapper>
));


